<template>
  <div class="page-wrapper">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col-2 col-lg-2 h-100 scroll-container category-container">




          <ul class="list-group">
            <draggable v-model="categories" :group="categories" @start="drag=true" @end="drag=false" @change="onCategoryReordered">
              <div v-for="(cat, index) in categories"  v-bind:id="'cat-parent-' + cat.id">
                <li class="list-group-item  text-left"  data-toggle="collapse" :data-target="'#cat-group-' + cat.id" aria-expanded="false">
                  <span class="side-menu-text font-weight-bold">{{cat.title}}</span>

                  <span class="collapse-button float-right rotate-if-collapsed"  :id="'category-toggle-'+cat.id"/>
                  <span><i class="fa fa-edit float-right" v-on:click.stop="showCategoryEdit(cat)"></i></span>
                </li>
                <div v-bind:id="'cat-group-' + cat.id" class="collapse" :aria-labelledby="'cat-parent-' + cat.id">
                  <draggable v-model="cat.list" :group="categories" @start="drag=true" @end="drag=false" @change="onSubCategoryReordered(index)">
                    <li v-for="(subCat, sindex) in cat.list" class="list-group-item sub-category text-left" v-on:click="openCategoryItems(subCat)" v-bind:class="{'category-selected': currentCatItem.id == subCat.id}">
                      <span class="side-menu-text" style="padding-left:20px;">{{subCat.title}}</span>
                      <span><i class="fa fa-edit float-right" v-on:click.stop="showCategoryEdit(subCat)"></i></span>
                    </li>
                  </draggable>
                  <li class="list-group-item">
                    <span v-on:click="showSubCategoryEdit(cat)"><i class="fas fa-plus"></i> 추가하기</span>
                  </li>
                </div>

              </div>
            </draggable>
            <li class="list-group-item text-left" v-on:click="showCategoryEdit()"><i class="fas fa-plus"></i> 추가하기</li>
          </ul>


        </div>
        <div class="col-10 col-lg-10  h-100" v-if="currentCatItem != false">

          <div class="container-fluid h-100">
            <div class="row h-100">
              <div class="col-12 col-lg-6  h-100 scroll-container">
                <div class="container">
                  <div class="row">
                    <div class="col-12 text-left border-btn-container">
                      <span class="border-btn" v-if="currentHighCatItem != false">{{currentHighCatItem.title}}</span>
                      <span class="border-btn" v-if="currentCatItem != false">{{currentCatItem.title}}</span>
                    </div>
                    <div class="col-12 text-right border-btn-container">
                      <span class="border-btn" v-on:click="showProductEdit()"><i class="fa fa-plus"></i> 상품 추가하기</span>

                    </div>
                  </div>
                </div>
                <table class="table">
                  <thead>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="text-left">상품명</th>
                    <th class="text-left">브랜드</th>
                    <th>가격</th>


                  </tr>
                  </thead>
                  <draggable v-model="products" :group="products" @start="drag=true" @end="drag=false" @change="onProductReordered" tag="tbody">
                    <tr class="product-item" v-for="(item, index) in products" :key="item.id" v-bind:class="{ 'category-selected': currentProductItem != false && currentProductItem.id == item.id}" v-on:click="openProductItem(item)">
                      <td>#{{item.id}}</td>
                      <td v-bind:class="{'sold-out':item.soldOut==true}" v-on:click.stop="toggleSoldOut(index)">{{item.soldOut==false?'판매중':'품절'}}</td>
                      <td>
                        <img :src="getFirstImage(item)" width="50px">

                      </td>
                      <td class="text-left">{{item.title}}</td>
                      <td class="text-left">{{item.brand}}</td>
                      <td>{{item.price}}</td>


                    </tr>
                  </draggable>
                </table>
              </div>
              <div class="col-6 col-lg-6 h-100 scroll-container " v-if="editProductItem == false && currentProductItem != false" style="padding-bottom: 100px;">
                <div class="container">
                  <div class="row">
                    <div class="col-12 text-right border-btn-container">
                      <span class="border-btn" v-on:click="showProductEdit(currentProductItem)"><i class="fas fa-edit"></i>수정</span>
                      <span class="border-btn" v-on:click="askDeleteProduct(currentProductItem)" ><i class="fas fa-trash"></i>지우기</span>

                    </div>
                  </div>

                  <div class="row">

                    <div class="col-12">
                      <div class="image-list-container">
                        <div class="image-item" v-if="currentProductItem.imageUrls.length > 0" v-for="(img, index) in currentProductItem.imageUrls" v-bind:style="{ backgroundImage: 'url(' + img +')'}">

                        </div>


                      </div>
                    </div>
                    <div class="col-12">
                      <div class="container">

                        <div class="row" v-if="currentProductItem.id > 0">
                          <label class="col-4 form-control">상품 링크 주소</label>
                          <div class="col-8 text-left">https://ukotrading.net/product?id={{currentProductItem.id}}<span v-if="currentProductItem.couponCode != undefined && currentProductItem.couponCode != null && currentProductItem.couponCode.length > 0">&code={{currentProductItem.couponCode}}</span>
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-4 form-control">상품명</label>
                          <input type="text" class="col-8 form-control" v-model="currentProductItem.title" disabled/>
                        </div>
                        <div class="row form-row">
                          <label class="col-4 form-control">태그 (첫화면, 검색)</label>
                          <div class="col-8 text-left tag-container">
                            <span v-for="tag in currentProductItem.tags">{{tag}}</span>
                          </div>

                        </div>

                        <div class="row">
                          <label class="col-4 form-control">브랜드(송장용)</label>
                          <input type="text" class="col-8 form-control" v-model="currentProductItem.brand" disabled/>
                        </div>


                      </div>
                      <div class="container">

                        <div class="row">
                          <label class="col-4 form-control">Dimension (mm)</label>
                          <input type="number" class="col-2 form-control" v-model="currentProductItem.x" disabled/>
                          <input type="number" class="col-2 form-control" v-model="currentProductItem.y" disabled/>
                          <input type="number" class="col-2 form-control" v-model="currentProductItem.z" disabled/>
                        </div>


                      </div>
                      <div class="container">

                        <div class="row">
                          <label class="col-4 form-control">가격</label>
                          <input type="number" class="col-8 form-control" v-model="currentProductItem.price" disabled/>
                        </div>

                        <div class="row text-left">
                          <label class="col-4 form-control">설명</label>
                          <div class="col-12" style="border: 1px solid #888;">
                            <p style="margin-top: 20px;" v-html="currentProductItem.description.replace(/\n/g, '<br />')"></p>
                          </div>

<!--                          <textarea class="col-12 form-control" rows="10" v-model="currentProductItem.description" disabled></textarea>-->
                        </div>



                        <hr>

                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-6 col-lg-6 h-100 scroll-container " v-if="editProductItem != false" style="padding-bottom: 100px;">
                <div class="container">
                  <div class="row">
                    <div class="col-12 text-right border-btn-container">
                      <span class="border-btn" v-on:click="updateProduct"><i class="fas fa-save"></i>저장</span>
                      <span class="border-btn" v-on:click="closeProductEdit"><i class="fas fa-close"></i>취소</span>

                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12">
                      <progress value="0" max="100" id="uploader"></progress>
                      <input accept="image/*" type="file" ref="file" value="upload" @change="fileBtn"/>
                      <div class="image-list-container">
                        <div class="image-item" v-if="editProductItem.imageUrls.length > 0" v-for="(img, index) in editProductItem.imageUrls" v-bind:style="{ backgroundImage: 'url(' + img +')'}">
                          <i class="fas fa-trash top-left-icon" v-on:click="onImageDeleted(index)"></i>
                        </div>

                      </div>
                    </div>
                    <div class="col-12">
                      <div class="container">
                        <div class="row" v-if="editProductItem.id > 0">
                          <label class="col-4 form-control">상품 링크 주소</label>
                          <div class="col-8 text-left">https://ukotrading.net/product?id={{editProductItem.id}}
                          </div>
                        </div>
                        <div class="row">
                          <label class="col-4 form-control">카테고리</label>
                          <select v-model="editProductItem.categoryId" class="col-8 form-control">
                            <template v-for="cat in categories">
                              <option v-for="cc in cat.list" :value="cc.id">{{cat.title}} / {{cc.title}}</option>
                            </template>
                          </select>
                        </div>
                        <div class="row">
                          <label class="col-4 form-control">상품명</label>
                          <input type="text" class="col-8 form-control" v-model="editProductItem.title"/>
                        </div>
                        <div class="row form-row">
                          <label class="col-4 form-control">태그(첫화면, 검색, 입력후 엔터키)</label>
                          <input-tag :key="'tags' + editProductItem.id" class="col-8" v-model="editProductItem.tags"></input-tag>
                        </div>
                        <div class="row form-row">
                          <label class="col-12 form-control text-left">첫화면에 사용되는 태그, 검색용으로도 사용</label>
                        </div>

                        <hr>
                        <div class="row">
                          <label class="col-4 form-control">브랜드(송장용)</label>
                          <input type="text" class="col-8 form-control" v-model="editProductItem.brand"/>
                        </div>
                      </div>
                      <div class="container">


                        <div class="row">
                          <label class="col-4 form-control">가격</label>
                          <input type="number" class="col-8 form-control" v-model="editProductItem.price"/>
                        </div>
                        <div class="row">
                          <label class="col-4 form-control">설명</label>
                          <textarea class="col-12 form-control" rows="30" v-model="editProductItem.description"></textarea>
                        </div>

                        <div class="row">
                          <label class="col-4 form-control">가로 (cm)</label>
                          <input type="number" class="col-8 form-control" v-model="editProductItem.x"/>
                        </div>
                        <div class="row">
                          <label class="col-4 form-control">세로 (cm)</label>
                          <input type="number" class="col-8 form-control" v-model="editProductItem.y"/>
                        </div>
                        <div class="row">
                          <label class="col-4 form-control">높이 (cm)</label>
                          <input type="number" class="col-8 form-control" v-model="editProductItem.z"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="form-container" v-if="editCategoryItem!=false">
      <div class="form-inner-container">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h4>
                <span v-if="editCategoryItem.id == 0">카테고리 추가</span>
                <span v-if="editCategoryItem.id > 0">{{editCategoryItem.title}}</span>
              </h4>
            </div>
          </div>
          <div class="row">
            <label class="col-4 form-control">카테고리 이름</label>
            <input class="col-8 form-control" v-model="editCategoryItem.title"/>
          </div>
          <div class="row">
            <label class="col-4 form-control">카테고리 이동</label>
            <select class="col-8 form-control" v-model="editCategoryItem.parentId">
              <option value="0">상위폴더</option>
              <option v-for="(cat, index) in categories" :value="cat.id">{{cat.title}}</option>
            </select>
          </div>
          <div class="row">
            <label class="col-4 form-control">옵션</label>
            <div class="col-8 text-left">
              <span class="border-selector" v-bind:class="{'border-btn-selected': editCategoryItem.frontPage === true}" v-on:click="enableFrontPage()" >첫페이지</span>
            </div>
          </div>

        </div>
        <div class="form-button-container">
          <div class="container">
            <div class="row" style="margin-top:30px;">

              <div class="col-4 text-left">
                <span class="border-btn" v-if="editCategoryItem.id > 0" v-on:click="deleteCategoryAsk"><i class="fa fa-trash"> 카테고리 삭제</i></span>
              </div>
              <div class="col-8 text-right">
                <span class="border-btn" v-on:click="closeCategoryEdit"><i class="fa fa-close"> 닫기</i></span>
                <span class="border-btn" v-on:click="submitCategoryEdit"><i class="fa fa-save"> 업데이트</i></span>

              </div>


            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="spinner-container" v-if="isLoading">
      <div class="spinnermedium">
        <span class="bgtopl"><span class="highlighttopl"></span></span>
        <span class="bgtopr"><span class="highlighttopr"></span></span>
        <span class="bottomrow">
          <span class="bgbtml"><span class="highlightbtml"></span></span>
          <span class="bgbtmr"><span class="highlightbtmr"></span></span>
        </span>
      </div>
    </div>
    <v-dialog width="500"/>
  </div>
</template>

<script>
    import {getCategories,
        updateProductItem, updateCategoryItem, getProductsByCategory, getCategoryById,
        getProductById, getProductStock, addStock, updateProductStock, updateProductItems, updateCategoryItems,
        getProductStockListByState, getProductStockListByStateRange, getProductStockListByStateAndTimeRange, deleteProduct, deleteCategory,
        getProductSoldStockListByStateAndTimeRange, getProductInStockListByStateAndTimeRange} from '../api/product'
    import {millisToDate, millisToReadable, getStockStateString, getStockTypeString, printLabel} from '../api/utils'
    import {sendEmail} from "../api/user";
    import {getMetasByType} from '../api/meta'
    import AWS from 'aws-sdk';
    import VueBarcode from 'vue-barcode';
    import InputTag from 'vue-input-tag'
    import ImageInput from "./ImageInput";
    import moment from 'moment';
    import Multiselect from 'vue-multiselect';
    import draggable from 'vuedraggable'

    import * as firebase from "firebase/app";
    import "firebase/auth";
    import "firebase/storage";


    export default {
        name: "Products",
        data() {
            return {
                currentCatIndex:-1,
                currentCatItem: false,
                currentHighCatItem: false,
                selectedProductIndex: -1,
                categories:[],
                products: [],

                editCategoryItem: false,
                editProductItem: false,
                currentProductItem: false,
                detailedProductItem: false,
                currentProductStock:[],
                editStockItem: false,
                stockListToSubmit: [],
                printItems:[],
                isLoading:false,
                stockView: 0,
                searchFilter: {
                    from:'',
                    to:'',
                },
                orderTypes:[],
                orderTypeOptions:[],
                newOptionTitle:'',
                email:{
                    subject:'',
                    content:'',
                }
            }
        },
        components: {
            'barcode': VueBarcode,
            InputTag,
            ImageInput,
            'multiselect': Multiselect,
            draggable,
        },
        created() {
            this.getProductOptions();
            this.getCategoryList();


        },
        mounted() {
            let to = new Date();
            let from = to.getTime() - (30 * 1000 * 60 * 60 * 24);

            this.$data.searchFilter.from = millisToDate(from, '-');
            this.$data.searchFilter.to = millisToDate(to.getTime(), '-');
            console.log(this.$data.searchFilter);
        },
        computed: {

            getProductBarcode: function() {
                // If barcode is not available
                // Generate 4700 + [productId] + [000000000]
                let product = this.$data.products[this.$data.selectedProductIndex];

                if(product.barCode !== '' || product.barCode.length > 0) {
                    return product.barCode;
                }
                if(product.productBarCode !== '' || product.productBarCode.length > 0) {
                    return product.productBarCode;
                }
                return '4700' + this.zeroPad(product.id, 8) + this.zeroPad(0, 8)
            }
        },
        methods: {
            showModal: function(title, message) {
                console.log("show modal " + title  + " : " + message);
                this.$modal.show('dialog',{
                    title: title,
                    text: message,
                    buttons:[
                        {title:'Close'}
                    ]
                })
                return;
            },
            zeroPad: function(num, numZeros) {
                var n = Math.abs(num);
                var zeros = Math.max(0, numZeros - Math.floor(n).toString().length );
                var zeroString = Math.pow(10,zeros).toString().substr(1);
                if( num < 0 ) {
                    zeroString = '-' + zeroString;
                }

                return zeroString+n;
            },
            toDate: function(time) {

                return millisToDate(time);
            },
            getProductOptions: function() {
                let self = this;
                getMetasByType("order_type")
                    .then(function(data) {
                        if(data.success == true) {
                            self.$data.orderTypes = data.item;
                            for(let i = 0 ; i < self.$data.orderTypes.length ; i++) {
                                self.$data.orderTypeOptions.push(self.$data.orderTypes[i].title);
                            }
                            console.log("Types");
                            console.log(self.$data.orderTypeOptions);
                        }
                    })
                    .catch(function(err) {

                    })
            },
            stockSaleGrossEntered: function() {
                if( this.$data.editStockItem.salesGross.length == 0) {
                    this.$data.editStockItem.salesVat = 0;
                    this.$data.editStockItem.salesNet = 0;
                } else {
                    this.$data.editStockItem.salesVat = (this.$data.editStockItem.salesGross / 6).toFixed(2);
                    this.$data.editStockItem.salesNet = (this.$data.editStockItem.salesGross - this.$data.editStockItem.salesVat).toFixed(2);
                }
            },
            stockGrossEntered: function() {
                if( this.$data.editStockItem.purchaseGross.length == 0) {
                    this.$data.editStockItem.purchaseVat = 0;
                    this.$data.editStockItem.purchaseNet = 0;
                } else {
                    this.$data.editStockItem.purchaseVat = (this.$data.editStockItem.purchaseGross / 6).toFixed(2);
                    this.$data.editStockItem.purchaseNet = (this.$data.editStockItem.purchaseGross - this.$data.editStockItem.purchaseVat).toFixed(2);
                }
            },
            productStockTypeString: function(type) {
                return getStockTypeString(type);
            },
            getStockStateString: function(state) {
                return getStockStateString(state);
            },
            stockTypeString: function(type) {
                if(type==='stock_in') {
                    return '입고';
                } else if(type==='stock_out') {
                    return '출고';
                } else if(type==='stock_correction') {
                    return '재고조사';
                }
                return 'Unknown';
            },
            stockDetailedTypeString: function(type) {
                if(type === 'purchase') {
                    return '구매';
                }else if(type === 'return') {
                    return '반품';
                } else if(type === 'shop_sales') {
                    return '매장판매';
                } else if(type === 'online_sales') {
                    return '온라인판매';
                } else if(type === 'correction') {
                    return '재고조사';
                }
                return 'unknown';
            },
            getColourList: function(colours) {
                console.log("getColourList " + colours);
                let list = [];
                if(colours.length > 0) {
                    list = colours.split(',');
                }
                list.unshift("select");
                console.log(list);
                return list;
            },
            getCategoryList: function() {
                let self = this;

                getCategories()
                    .then(function(data){
                        if(data.success == true) {
                            self.$data.categories = data.item;
                        }
                    })
                    .catch(function(err) {

                    })
            },
            getCategoryProducts: function(index) {
                let cid = this.$data.categories[index].id;

                let self = this;
                getProductsByCategory(cid)
                    .then(function(data){
                        if(data.success == true) {
                            console.log(data.item);
                            self.$data.categories[index].list = data.item;
                        }
                    })
                    .catch(function(err){

                    })
            },
            getProduct: function(id) {
                getProductById(id)
                    .then(function (data) {
                        if (data.success == true) {

                        }

                    })
                    .catch(function (err) {

                    })
            },
            getCategory: function(id) {
                getCategoryById(id)
                    .then(function(data){
                        if(data.success == true) {

                        }
                    })
                    .catch(function(err) {

                    })
            },
            enableFrontPage: function() {
                console.log("toggleFrontPage")
                console.log(this.$data.editCategoryItem);
                this.$data.editCategoryItem.frontPage = !(this.$data.editCategoryItem.frontPage);
                console.log("toggleFrontPage " + this.$data.editCategoryItem.frontPage);
                console.log(this.$data.editCategoryItem);
            },
            closeCategoryEdit: function() {
                this.$data.editCategoryItem = false;
            },
            deleteCategoryAsk: function() {
                let self = this;
                this.$modal.show('dialog',{
                    title: this.$data.editCategoryItem.title + " 카테고리 삭제",
                    text: "삭제하면 해당 카테고리의 모든 상품과 재고/판매 기록 모두 삭제됩니다. 삭제하시겠습니까?",
                    buttons:[
                        {
                            title:'아니요',
                            handler:() => {
                                self.$modal.hide('dialog');
                            }
                        },
                        {
                            title:"지우기",
                            handler:() => {
                                self.$modal.hide('dialog');
                                self.deleteCategoryItem(self.$data.editCategoryItem);
                            }

                        }
                    ]
                })
            },
            deleteCategoryItem: function(item) {
                let self = this;
                this.isLoading = true;
                console.log("deleetecategory " + item.id);
                deleteCategory(item.id)
                    .then(function(data) {
                        self.isLoading = false;
                        console.log("deleteCategory res");
                        console.log(data);
                        if(data.success == true) {
                            for(let i = 0 ; i < self.$data.categories.length ; i++ ) {
                                if(self.$data.categories[i].id === data.item.id) {
                                    console.log("Deleted product found from list to delete");
                                    if(self.$data.currentCatIndex >= 0 &&
                                        self.$data.categories[self.$data.currentCatIndex].id !== undefined &&
                                        self.$data.categories[i].id === self.$data.categories[self.$data.currentCatIndex].id) {
                                        console.log("Deleted product's stocks found from list to delete");
                                        self.$data.currentProductStock = [];
                                    }

                                    //delete

                                    self.$data.categories.splice(i,1);
                                    self.$data.selectedProductIndex = -1;
                                    self.$data.editCategoryItem = false;
                                    self.$data.currentCatIndex = -1;
                                    return;
                                }
                            }

                        }
                    })
                    .catch(function(err) {
                        self.isLoading = false;
                        console.log("Delete category error " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            submitCategoryEdit: function() {

                console.log("submitCategoryEdit");
                console.log(this.$data.editCategoryItem);
                // Add position if new
                if(this.$data.editCategoryItem.id == 0) {
                    this.$data.editCategoryItem.pos = this.$data.categories.length;
                }
                let positionChange = false;
                if(this.$data.editCategoryItem.parentId != this.$data.editCategoryItem.parentId.orgParentId) {
                    positionChange = true;
                }
                this.updateCategory(this.$data.editCategoryItem, positionChange);

            },
            updateCategory: function(category, refresh = false) {
                let self = this;
                console.log("update category");
                console.log(category);
                updateCategoryItem(category)
                    .then(function(data){
                        self.$data.editCategoryItem = false;
                        if(data.success == true) {

                            if(refresh) {
                                self.getCategoryList();
                                return;
                            }
                            let item = data.item;

                            if(item.parentId == 0) {
                                for (let i = 0; i < self.$data.categories.length; i++) {
                                    if (self.$data.categories[i].id == item.id) {
                                        self.$data.categories.splice(i, 1, item);
                                        return;
                                    }
                                }
                                //If not found, add to last
                                self.$data.categories.push(item);
                            } else {
                                for (let i = 0; i < self.$data.categories.length; i++) {
                                    if (self.$data.categories[i].id == item.parentId) {

                                        for(let j = 0 ; j < self.$data.categories[i].list.length ; j++) {
                                            if(self.$data.categories[i].list[j].id == item.id) {
                                                self.$data.categories[i].list.splice(j, 1, item);
                                                return;
                                            }

                                        }
                                        self.$data.categories[i].list.push(item);
                                        return;
                                    }
                                }
                            }


                        }
                    })
                    .catch(function(err){
                        self.$data.editCategoryItem = false;
                    })
            },

            showSubCategoryEdit: function(parent) {
                  this.$data.editCategoryItem = {
                      id:0,
                      parentId:parent.id,
                      orgParentId: parent.id,
                      title:'',
                  }

            },
            showCategoryEdit: function(item = null) {
                console.log("showCategoryEdit ");
                if(item == null) {
                    this.$data.editCategoryItem = {
                        id:0,
                        parentId:0,
                        orgParentId:0,
                        title:'',
                    }
                } else {
                    console.log("show edit view");
                    this.$data.editCategoryItem = JSON.parse(JSON.stringify(item));
                    console.log(this.$data.editCategoryItem);
                }
            },

            getCategoryPathString: function() {

            },
            openCategoryItems: function(catItem) {

                // console.log("openCategoryItems " + index);
                let self = this;
                this.$data.currentProductItem = false;
                this.$data.editProductItem = false;
                this.$data.currentCatItem = catItem;
                this.$data.currentHighCatItem = false;
                for(let i = 0 ; i < this.$data.categories.length ; i++) {
                    if(this.$data.categories[i].id == this.$data.currentCatItem.parentId) {
                        this.$data.currentHighCatItem = this.$data.categories[i];
                        break;
                    }
                }
                //this.$data.currentCatIndex = index;
                this.$data.selectedProductIndex = -1;
                this.$data.products = [];
                console.log("get category " + this.$data.currentCatItem.id);
                getProductsByCategory(this.$data.currentCatItem.id)
                    .then(function(data){
                        console.log("openCategoryItems");
                        console.log(data);
                        if(data.success == true) {
                            self.$data.products = data.item;
                            console.log(self.$data.products);

                        } else {
                            self.$data.products = [];
                        }
                    })
                    .catch(function(err){

                    })

            },
            toggleSoldOut: function(i) {
                this.$data.products[i].soldOut = !this.$data.products[i].soldOut;
                updateProductItem(this.$data.products[i])
                .then(function(data) {
                    if(data.success == false) {
                        window.alert("Failed to update " + data.message);
                    }
                })
                .catch(function(err) {
                    let msg = "Error happened " + err;
                    if(err.response != undefined) {
                        msg += " " + err.response;
                    }
                    window.alert(msg);
                })
            },
            onProductReordered: function() {
                console.log("onProductReordered");
                for(let i = 0 ; i < this.$data.products.length ; i ++) {
                    this.$data.products[i].pos = i;
                }
                //Update products
                console.log(this.$data.products);
                updateProductItems(this.$data.products)
                    .then(function(data) {
                        if(data.success == true) {
                            console.log("Product reorder success");
                        } else {
                            console.log("Product reorder failed " + data.message);
                        }
                    })
                    .catch(function(err) {
                        console.log("Product reorder error " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })

                //openCategoryItems
            },
            onSubCategoryReordered: function(index) {
                for(let i = 0 ; i < this.$data.categories[index].list.length ; i ++) {
                    this.$data.categories[index].list[i].pos = i;
                }
                updateCategoryItems(this.$data.categories[index].list)
                    .then(function(data) {
                        if(data.success == true) {

                        }
                    })
                    .catch(function(err) {

                    })
            },
            onCategoryReordered: function() {
                for(let i = 0 ; i < this.$data.categories.length ; i ++) {
                    this.$data.categories[i].pos = i;
                }
                //update categories
                updateCategoryItems(this.$data.categories)
                    .then(function(data) {
                        if(data.success == true) {

                        }
                    })
                    .catch(function(err) {

                    })
            },

            showProductEdit(item = false) {
                if(item == false) {
                    this.$data.currentProductItem = false;
                    this.$data.editProductItem = {
                        id:0,
                        parentId:0,
                        categoryId:this.$data.currentCatItem.id,
                        type:'',
                        title:'',
                        brand:'',
                        year:0,
                        x:0,
                        y:0,
                        z:0,
                        barCode:'',
                        productBarCode:'',
                        price:0,
                        deliveryCharge:0,
                        status:0,
                        description:"",
                        imageUrls:[],
                        tags:[],
                        purchasePrice:0,
                        purchasedUrl:'',
                    }
                } else {
                    console.log("showProductEdit");
                    // console.log(this.$data.products[index]);

                    //Convert tags to array for tag input
                    // if(item.tags.length > 0) {
                    //     item.tags = item.tags.split(',');
                    // } else {
                    //     item.tags = [];
                    // }
                    this.$data.editProductItem = JSON.parse(JSON.stringify(item));

                    console.log("Edit PRdouct");
                    console.log(this.$data.editProductItem);
                    // if(this.$data.editProductItem.imageUrls.length > 0) {
                    //     this.$data.editProductItem.imageUrls = this.$data.editProductItem.imageUrls.split(',');
                    // } else {
                    //     this.$data.editProductItem.colourList = [];
                    // }


                }
            },
            closeProductEdit: function() {
                this.$data.editProductItem = false;
            },
            askDeleteProduct: function(item) {
                let self = this;
                this.$modal.show('dialog', {
                    title:'',
                    text: this.$data.currentProductItem.title + " 지우시겠습니까?",
                    buttons:[
                        {
                            title:'No',
                            handler:()=>{
                                self.$modal.hide('dialog');
                            }
                        },
                        {
                            title:'Yes Empty',
                            handler:()=>{
                                self.$modal.hide('dialog');
                                self.deleteProductItem(item);
                            }
                        }
                    ]
                })
            },

            deleteProductItem: function(item) {
                let self = this;
                this.isLoading = true;
                deleteProduct(item.id)
                    .then(function(data) {
                        self.isLoading = false;
                        if(data.success == true) {
                            for(let i = 0 ; i < self.$data.products.length ; i++ ) {
                                if(self.$data.products[i].id === data.item.id) {
                                    console.log("Deleted product found from list to delete");
                                    if(self.$data.selectedProductIndex >= 0 &&
                                        self.$data.products[self.$data.selectedProductIndex].id !== undefined &&
                                        self.$data.products[i].id === self.$data.products[self.$data.selectedProductIndex].id) {
                                        console.log("Deleted product's stocks found from list to delete");
                                        self.$data.currentProductStock = [];
                                    }

                                    //delete

                                    self.$data.products.splice(i,1);
                                    self.$data.selectedProductIndex = -1;
                                    self.$data.editProductItem = false;
                                    self.$data.currentProductItem = false;
                                    return;
                                }
                            }

                        }
                    })
                    .catch(function(err) {
                        self.isLoading = false;
                        console.log("Delete product error " + err);
                        if(err.response != undefined) {
                            console.log(err.response);
                        }
                    })
            },
            updateProduct: function() {
                let self = this;
                console.log("updateProduct");
                console.log(this.$data.editProductItem);
                if(this.$data.editProductItem.title.length == 0) {
                    this.showModal("ERROR", "품명을 입력해주세요");
                    return;
                }
                // if(this.$data.editProductItem.brand.length == 0) {
                //     this.showModal("ERROR", "브랜드 입력해주세요");
                //     return;
                // }
                if(this.$data.editProductItem.price.length == 0) {
                    this.showModal("ERROR", "판매 가격을 입력해주세요");
                    return;
                }
                if(this.$data.editProductItem.imageUrls.length > 0) {
                    this.$data.editProductItem.imageUrls = this.$data.editProductItem.imageUrls.join(',');
                } else  {
                    this.$data.editProductItem.imageUrls = "";
                }

                if(this.$data.editProductItem.tags != null && this.$data.editProductItem.tags.length > 0) {
                    this.$data.editProductItem.tags = this.$data.editProductItem.tags.join(',');
                } else {
                  this.$data.editProductItem.tags = '';
                }
                console.log("update product");
                console.log(this.$data.editProductItem);
                updateProductItem(this.$data.editProductItem)
                    .then(function(data){
                        console.log("updateProductItem");
                        console.log(data);
                        self.$data.editProductItem = false;
                        if(data.success == true) {
                            for(let i = 0 ; i < self.$data.products.length ; i++) {
                                if(self.$data.products[i].id == data.item.id) {
                                    // data.item.price = (data.item.price/100).toFixed(2);
                                    if(self.$data.currentCatItem.id == data.item.categoryId) {
                                        self.$data.products.splice(i, 1, data.item);
                                        self.openProductItem(self.$data.products[i]);
                                    } else {
                                        self.$data.products.splice(i, 1);
                                        self.$data.currentProductItem = false;
                                    }

                                    return;
                                }
                            }
                            // data.item.price = (data.item.price/100).toFixed(2);
                            if(self.$data.currentCatItem.id == data.item.categoryId) {
                                self.$data.products.push(data.item);
                                self.openProductItem(self.$data.products[self.$data.products.length - 1])
                            } else {
                                self.$data.currentProductItem = false;
                            }

                        }
                    })
                    .catch(function(err){
                        console.log(err);
                        console.log(err.response);
                    })
            },
            openProductItem: function(item) {
                let self = this;
                this.$data.newOptionTitle = '';

                getProductById(item.id)
                    .then(function(data) {
                        if(data.success == true) {
                            self.setCurrentProduct(data.item);
                        }
                    })
                    .catch(function(err) {

                    })

                //this.getProductStockInItems();
            },

            setCurrentProduct: function(item) {
                this.$data.editProductItem = false;
              console.log("Set Current product");
              console.log(item)
                this.$data.currentProductItem = JSON.parse(JSON.stringify(item));
                if(this.$data.currentProductItem.imageUrls.length > 0) {

                    this.$data.currentProductItem.imageUrls = this.$data.currentProductItem.imageUrls.split(',');
                } else {
                    this.$data.currentProductItem.imageUrls = [];
                }

                if(this.$data.currentProductItem.tags != null && this.$data.currentProductItem.tags.length > 0) {
                    this.$data.currentProductItem.tags = this.$data.currentProductItem.tags.split(',');
                } else {
                    this.$data.currentProductItem.tags = [];
                }

                console.log("Current product");
                console.log(this.$data.currentProductItem)
                this.initialiseEmailData();
            },

            addLabelItem(productId, stockId, productTitle, description, brand, price) {
                for(let i = 0 ; i < this.$data.printItems.length ; i++) {
                    if(this.$data.printItems[i].pid == productId &&
                        this.$data.printItems[i].title === productTitle &&
                        this.$data.printItems[i].brand === brand &&
                        this.$data.printItems[i].price === price &&
                        this.$data.printItems[i].description === description) {
                        this.$data.printItems[i].barcode += ",4700" + this.zeroPad(productId, 8) + this.zeroPad(stockId, 8)
                        return;
                    }
                }

                let item = {
                    barcode: "4700" + this.zeroPad(productId, 8) + this.zeroPad(stockId, 8),
                    pid: productId,
                    stockId: stockId,
                    title: productTitle,
                    description: description,
                    brand: brand,
                    price: price
                };
                this.$data.printItems.push(item);
            },
            deleteItem: function(index) {
                let self = this;
                this.$modal.show('dialog',{
                    title: "삭제",
                    text: "삭제하시겠습니까?",
                    buttons:[
                        {
                            title:'아니요',
                            handler:() => {
                                self.$modal.hide('dialog');
                            }
                        },
                        {
                            title:"지우기",
                            handler:() => {
                                self.$modal.hide('dialog');
                                self.confirmDeleteItem(index);
                            }

                        }
                    ]
                })
            },
            confirmDeleteItem: function(index) {
                this.$data.currentProductStock[index].deleted = true;
                let self = this;
                console.log("confirmDeleteItem ");
                // let item = {
                //     id: this.$data.currentProductStock[index].id,
                //     deleted: true,
                // }
                // console.log(item);
                this.updateStockItem(this.$data.currentProductStock[index]);
                // addStock(this.$data.currentProductStock[index])
                //     .then(function(data) {
                //         //self.$data.editStockItem = false;
                //         if (data.success === true) {
                //             if(data.item.deleted == true) {
                //                 self.$data.currentProductStock.splice(index, 1);
                //                 console.log("delete success");
                //                 console.log(data.item);
                //                 self.updateProductStock(data.item.productId);
                //             }
                //         }
                //     })
                //     .catch(function(err) {
                //         console.log("update stock item to delete failed " + err);
                //         if(err.response != undefined) {
                //             console.log(err.response);
                //         }
                //     })
            },

            printItem: function(index) {
                let barcode = "4700" + this.zeroPad(this.$data.products[this.$data.selectedProductIndex].id, 8)
                    + this.zeroPad(this.currentProductStock[index].id, 8);

                this.$data.isLoading = true;
                let self = this;
                printLabel(barcode,
                    this.$data.products[this.$data.selectedProductIndex].title,
                    this.currentProductStock[index].colour,
                    this.$data.products[this.$data.selectedProductIndex].brand,
                    this.$data.products[this.$data.selectedProductIndex].price.toFixed(2))
                    .then(function(data){
                        self.$data.isLoading = false;
                        if(data.success) {

                        } else {
                            console.log("Printer returned false");
                        }
                    })
                    .catch(function(err){
                        self.$data.isLoading = false;
                        console.log("PRinter err " + err);
                        if(err.response != undefined) {
                            console.log(err.response)
                        }
                    })
            },
            printLabelItems: function() {
                if(this.$data.printItems.length == 0) {
                    return;
                }

                //let barcode = "4700" + this.zeroPad(this.$data.printItems[0].pid, 8) + this.zeroPad(this.$data.printItems[0].stockId, 8);

                let self = this;
                self.$data.isLoading = true;
                printLabel(this.$data.printItems[0].barcode, this.$data.printItems[0].title, this.$data.printItems[0].description,
                    this.$data.printItems[0].brand, this.$data.printItems[0].price.toFixed(2))
                    .then(function(data){
                        self.$data.isLoading = false;
                        if(data.success) {
                            self.$data.printItems.splice(0, 1);
                            self.printLabelItems();
                        } else {
                            console.log("Printer returned false");
                        }
                    })
                    .catch(function(err){
                        self.$data.isLoading = false;
                        console.log("PRinter err " + err);
                        if(err.response != undefined) {
                            console.log(err.response)
                        }
                    })


            },

            refreshProduct(pid) {
                let self = this;
                getProductById(pid)
                    .then(function(data){
                        if(data.success === true) {
                            if(self.$data.products[self.$data.selectedProductIndex].id === data.item.id) {


                                self.$data.products.splice(self.$data.selectedProductIndex, 1, data.item);
                                return;
                            }

                            for(let i = 0 ; i < self.$data.products.length ; i++) {
                                if(self.$data.products[i].list.length > 0) {
                                    if(self.$data.products.id === data.item.id) {
                                        self.$data.products.splice(j, 1, data.item);
                                        return;
                                    }

                                }
                            }

                            console.log("Cannot find product item to update");
                        }
                    })
                    .catch(function(err){

                    })
            },

            addOptionItem: function() {
                let newItem = {
                    id:0,
                    title:'',
                    imageUrls:'',
                    parentId: this.$data.currentProductItem.id,
                }
                this.$data.currentProductItem.list.push(newItem);
            },
            newOptionItemEntered: function() {
                if(this.$data.newOptionTitle.length == 0) {
                    return;
                }
                let newItem = {
                    id:0,
                    title:this.$data.newOptionTitle,
                    imageUrls:'',
                    parentId: this.$data.currentProductItem.id,
                }
                let self = this;
                updateProductItem(newItem)
                    .then(function(data) {
                        if(data.success == true) {
                            self.$data.newOptionTitle = '';
                            self.$data.currentProductItem.list.push(data.item)
                        }
                    })
                    .catch(function(err) {

                    })
            },
            optionItemChanged: function(item) {
                updateProductItem(item)
                    .then(function(data) {

                    })
                    .catch(function(err) {

                    })
            },
            deleteOptionItem: function(item) {
                let self = this;
                deleteProduct(item.id)
                    .then(function(data) {
                        if(data.success == true) {
                            console.log("deleteOptionItem resp");
                            console.log(data);
                            for(let i = 0 ; i < self.currentProductItem.list.length ; i++) {
                                if(self.currentProductItem.list[i].id == data.item.id) {
                                    self.currentProductItem.list.splice(i, 1);
                                    return;
                                }
                            }
                        }
                    })
                    .catch(function(err) {

                    })
            },
            onImageDeleted: function(index) {
                if(index >= this.$data.editProductItem.imageUrls.length) {
                    console.log("Wrong index");
                    return;
                }
                this.$data.editProductItem.imageUrls.splice(index, 1);
            },
            onOptionItemImageSelected: function({image, index}) {
                console.log('New picture selected! ' + index);
                let id = index;
                let self = this;

                //return;
                if (image) {
                    var i = new Image();
                    i.onload = function() {
                        var imgW = i.width;
                        var imgH = i.height;

                        var proportion = 1.0;
                        if(imgH > imgW) {
                            proportion = 512/imgH;
                        } else {
                            proportion = 512/imgW;
                        }

                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');

                        // set its dimension to target size
                        canvas.width = imgW*proportion;
                        canvas.height = imgH*proportion;

                        // draw source image into the off-screen canvas:
                        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

                        // encode image to data-uri with base64 version of compressed image
                        //return canvas.toDataURL();
                        console.log(canvas);
                        var bob = canvas.toDataURL();
                        console.log('Picture loaded.');
                        console.log(bob);

                        /**
                         * Perform upload image
                         * and update db
                         */
                        self.uploadOptionImage(bob, id);
                    }
                    i.src = image;

                    // this.uploadImage(this.image);
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            uploadOptionImage: function(image, id) {
                let d = new Date();
                let name  =  moment(d).format('YYYYMMDD-hhmmss');

                let path = id + '/' + name + '.jpg';
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                    "accessKeyId" : "AKIAJK3BIVKNERMSV6KA",
                    "secretAccessKey" : "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",
                    "region" : "ap-northeast-2"
                });

                let block = image.split(";");
                // Get the content type of the image
                let contentType = block[0].split(":")[1];// In this case "image/gif"
                // get the real base64 content of the file
                let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

                // Convert it to a blob to upload
                let blob = this.b64toBlob(realData, contentType);

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'beibledu',
                    Key: path,
                    ContentType: contentType,
                    Body : blob,
                    ACL: 'public-read'
                };
                //return;
                let self = this;

                // Now upload to S3
                s3.putObject(params, function(err, res){
                    if(err) {
                        //Error
                        console.log("ERROR to upload " + err);

                    } else {
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        for(let i = 0 ; i < self.$data.currentProductItem.list.length ; i++) {
                            if(self.$data.currentProductItem.list[i].id == id) {
                                self.$data.currentProductItem.list[i].imageUrls = "https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path;
                                console.log("Now update optionItem");
                                console.log(self.$data.currentProductItem.list[i]);
                                updateProductItem(self.$data.currentProductItem.list[i])
                                    .then(function(data) {
                                        console.log("update Option Image ")
                                        console.log(data);

                                    })
                                    .catch(function(err) {
                                        console.log("update Option image erro " + err);
                                        if(err.response != undefined) {
                                            console.log(err.response);
                                        }
                                    })
                            }
                        }
                        //self.$data.editProductItem.imageUrls.push("https://borium.s3.eu-west-2.amazonaws.com/" + path)
                        /*
                                                updateProductItem(editProductItem).then(function(data) {
                                                    if(data.success == true) {
                                                        self.getProduct(data.item.id);
                                                    }
                                                }).catch(function(err){

                                                })

                        */
                    }
                });
            },
            fileBtn:function(e) {
              // e.preventDefault();
              const uploader = document.getElementById('uploader');
              //get file
              console.log("File Btn Added");
              console.log(e);
              let getFile = e.target.files[0];
              console.log("File name - " + getFile.name);
              //set storage ref
              let d = new Date();
              let name = moment(d).format('YYYYMMDD-hhmmss');
              let names = getFile.name.split('.');
              let path = 'uko-post/' + this.$data.currentProductItem.id + '-' + name + '.' + names[names.length-1];
              let storageRef = firebase.storage().ref();
              let mountainsRef = storageRef.child(path);
              let self = this;
              mountainsRef.put(getFile).on('state_changed',
                function progress(snapshot){

                  let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
                  console.log("percentage " + percentage);
                  uploader.value = percentage;
                },
                function error(err){
                  console.log(err);
                },
                function complete(){
                  console.log('complete upload https://storage.googleapis.com/uko-projects.appspot.com/' + path);
                  self.$data.editProductItem.imageUrls.push('https://storage.googleapis.com/uko-projects.appspot.com/' + path);
                  console.log(self.$data.editProductItem.imageUrls);
                }
              );
            },
            onItemImageSelected: function({image, index}) {
                console.log('New picture selected!');
                let self = this;

                //return;
                if (image) {
                    var i = new Image();
                    i.onload = function() {
                        var imgW = i.width;
                        var imgH = i.height;

                        var proportion = 1.0;
                        if(imgH > imgW) {
                            proportion = 512/imgH;
                        } else {
                            proportion = 512/imgW;
                        }

                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');

                        // set its dimension to target size
                        canvas.width = imgW*proportion;
                        canvas.height = imgH*proportion;

                        // draw source image into the off-screen canvas:
                        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

                        // encode image to data-uri with base64 version of compressed image
                        //return canvas.toDataURL();
                        console.log(canvas);
                        var bob = canvas.toDataURL();
                        console.log('Picture loaded.');
                        console.log(bob);

                        /**
                         * Perform upload image
                         * and update db
                         */
                        self.uploadImage(bob, index);
                    }
                    i.src = image;

                    // this.uploadImage(this.image);
                } else {
                    console.log('FileReader API not supported: use the <form>, Luke!')
                }
            },
            uploadImage: function(image, id) {
                let d = new Date();
                let name  =  moment(d).format('YYYYMMDD-hhmmss');

                let path = this.$data.editProductItem.id + '/' + name + '.jpg';
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                    "accessKeyId" : "AKIAJK3BIVKNERMSV6KA",
                    "secretAccessKey" : "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",
                    "region" : "ap-northeast-2"
                });

                let block = image.split(";");
                // Get the content type of the image
                let contentType = block[0].split(":")[1];// In this case "image/gif"
                // get the real base64 content of the file
                let realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

                // Convert it to a blob to upload
                let blob = this.b64toBlob(realData, contentType);

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'beibledu',
                    Key: path,
                    ContentType: contentType,
                    Body : blob,
                    ACL: 'public-read'
                };
                //return;
                let self = this;

                // Now upload to S3
                self.$data.isLoading = true;
                s3.putObject(params, function(err, res){
                    if(err) {
                        //Error
                        self.$data.isLoading = false;
                        console.log("ERROR to upload " + err);
                        self.showModal("", "업로드 에러입니다. " + err);
                    } else {
                        self.$data.isLoading = false;
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        self.$data.editProductItem.imageUrls.push("https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path)
                        console.log("https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path);
                    }
                });
            },
            b64toBlob: function(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                var byteCharacters = atob(b64Data);
                var byteArrays = [];

                for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    var slice = byteCharacters.slice(offset, offset + sliceSize);

                    var byteNumbers = new Array(slice.length);
                    for (var i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    var byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                var blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },
            getFirstImage: function(item) {
                if(item.imageUrls.length > 0) {
                    return item.imageUrls.split(',')[0];
                }
                return 'https://borium.s3.eu-west-2.amazonaws.com/beible/ic-book.png';
            },



            onfileselectorClick: function(refId){
                console.log("onfileselectorClick " + refId);
                this.$refs[refId][0].value = "";
                this.$refs[refId][0].click()
            },
            removeAttachment: function(li) {
                if(this.$data.editProductItem.linkUrl.length < li+1) {
                    return;
                }
              this.$data.editProductItem.linkUrl.splice(li, 1);
            },
            addFilePickedUp: function(e) {
                console.log("addFilePickedUp " );
                let self = this;
                if (e.target != undefined) {
                    if (e.target.files != undefined) {
                        let droppedFiles = e.target.files;
                        ([...droppedFiles]).forEach(file => {
                            console.log("pickedup " + file.type + ' ' + file.name);
                            self.uploadFileAWS(file, file.name, file.type);
                        })
                    }
                }
            },

            uploadFileAWS: function(file, name, type) {
                let d = new Date();
                name  =  moment(d).format('YYYYMMDD-hhmmss') + '-' + name;

                let path = this.$data.editProductItem.id + '/' + name;
                //var path = this.$data.menus[index].id + '/' + name + '.jpg';
                console.log("Path: " + path + " type:");
                //return;
                AWS.config.update({
                    "accessKeyId" : "AKIAJK3BIVKNERMSV6KA",
                    "secretAccessKey" : "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",
                    "region" : "ap-northeast-2"
                });

                // Create a FormData and append the file with "image" as parameter name
                //var formDataToUpload = new FormData(form);
                let s3 = new AWS.S3();
                let params = {
                    Bucket: 'beibledu',
                    Key: path,
                    ContentType: type,
                    Body : file,
                    ACL: 'public-read'
                };
                //return;
                let self = this;
                self.$data.isLoading = true;
                // Now upload to S3
                s3.putObject(params, function(err, res){
                    if(err) {
                        self.$data.isLoading = false;
                        //Error
                        console.log("ERROR to upload " + err);
                        self.showModal("", "업로드 에러입니다. " + err);

                    } else {
                        self.$data.isLoading = false;
                        //On success, update item
                        console.log("Success to upload" + res);
                        console.log(res);
                        self.$data.editProductItem.linkUrl.push("https://beibledu.s3.ap-northeast-2.amazonaws.com/" + path);
                    }
                });
            },

        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css" scoped>
  .side-menu {
    position: absolute;
    left: 0;
    overflow-x: hidden;
    width:0;
    height: 100%;
    background: blue;
    color: white;
    transition: 0.5s;
    z-index: 1000;


  }
  .side-menu.show {
    width: 200px;
    padding-top:70px;
  }
  .category-container {
    background: gray;
    border-right: 1px solid #2c3e50;
  }
  .category-container li {
    background: white;
  }
  .category-container i {
    font-size:22px;
  }
  .list-group-item.category-selected {
    background: blue;
    color:white;
  }
  .list-group {
    width:100%;
    background: inherit;

  }
  .list-group-item {
    background: inherit;
    cursor: pointer;
  }

  .product-item.category-selected {
    background: blue;
    color:white;
  }

  .form-container {
    position: absolute;
    background: rgba(0,0,0,0.4);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 998;
  }
  .form-inner-container {
    position: absolute;
    width: 80%;
    max-width: 700px;
    height: 80%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background: white;
    padding:50px;
    padding-bottom:70px;
    overflow-y: scroll;
  }
  .form-button-container {
    position: sticky;
    bottom:-70px;
    left: 0;
    width: 100%;
    padding:20px;
    background: white;
  }
  label.form-control {
    border:none;
  }
  .stock-in {
    border-left:5px solid blue;
  }
  .stock-out {
    border-left:5px solid red;
  }
  .stock-correction {
    border-left:5px solid green;
  }
  .price-input {
    max-width:100px;
    min-width:100px;
    -webkit-appearance: none;
    margin: 0;
  }
  .border-btn-container {
    height: 50px;
    line-height: 50px;
  }
  .border-btn {
    border: 1px solid gray;
    padding:5px 10px 5px 10px;
    border-radius: 2px;
    cursor: pointer;

    transition: background 0.1s ease-in-out;
  }
  .border-btn:hover {
    background: #fcde6c;
  }
  .border-btn-select {
    background:blue;
    color:white;
  }
  .border-selector {
    border: 1px solid gray;
    padding:5px 10px 5px 10px;
    border-radius: 2px;
    cursor: pointer;
  }
  .border-btn-selected {
    background: blue;
    color: white;
  }
  .collapse-button {
    width: 40px;
    height: 40px;
    margin-top: -10px;
    margin-bottom: -10px;
    margin-right: -15px;
    background-image: url('/static/ic_collapse.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: 20px 20px;
    cursor: pointer;
  }
  .rotate-if-collapsed {
    -webkit-transition: 0.3s ease-in-out;
    -moz-transition: 0.3s ease-in-out;
    -o-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
  }
  /**
  펼치기 아이콘으로 expand/collapse할 경우
   */
  [data-toggle="collapse"][aria-expanded="true"].rotate-if-collapsed {
    -webkit-transform: rotate(180deg);
    -moz-transform:    rotate(180deg);
    -ms-transform:     rotate(180deg);
    -o-transform:      rotate(180deg);
    transform:         rotate(180deg);
  }

  /**
  div안에 아이콘이 child로 들어가있고, div를 클릭하여 expand/collapse할 경우의 style
   */
  [data-toggle="collapse"][aria-expanded="true"] .rotate-if-collapsed {
    -webkit-transform: rotate(180deg);
    -moz-transform:    rotate(180deg);
    -ms-transform:     rotate(180deg);
    -o-transform:      rotate(180deg);
    transform:         rotate(180deg);
  }
  .low-stock-item {
    background:red;
    color: white;
  }
  .image-list-container {
    height: 300px;

    overflow-x: scroll;
    white-space: nowrap;

  }
  .image-list-container .image-item {

    height: 250px;
    width:250px;
    display: inline-block;
    margin-left: 10px;
  }
  .image-item {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;

    background-color: gray;
  }
  .top-left-icon {
    position: absolute;
    top: 10px;
    right:10px;
    color: red;
    background-color: white;
    padding:10px;
    box-shadow: 5px 5px 5px gray;
    border-radius: 50%;

  }
  .img-input-container {
    height: 250px;
    display: inline-block;
    margin-left: 10px;
  }
  .option-img-input-container {
    width: 100px;
    height: 100px;
  }
  .tag-container {
    /*width: 100%;*/
    /*padding:10px;*/
    /*text-align: left;*/
    line-height: 35px;

  }
  .tag-container > span {
    padding:3px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 5px;
    border:1px solid #CCCCCC;
    margin-right:10px;
  }
  .sold-out {
    background: red;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Products.vue